export const teamTypes = {
    A: 'a',
    B: 'b',
}
